import React from 'react';

import './Spinner.css';

// import spinnerGIF from '../../../../assets/images/Spinning_Ashoka_Chakra.gif';

// const spinner = props => <img src={spinnerGIF} alt="spinner" />;

const spinner = () => <div className="Loader">Loading...</div>;

export default spinner;



// WEBPACK FOOTER //
// ./src/App/components/UI/Spinner/Spinner.jsx